import { UzPageHeader } from '@utazzo/ui';
import { motion } from 'framer-motion';
import React, { type ReactNode } from 'react';

import { fadeUp, stagger } from '@/lib/motion';

export interface PageShellProps {
  title: ReactNode;
  description?: ReactNode;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * Standard admin page layout. Reuses UzPageHeader for the title row and wraps
 * the page in a stagger container so the header + content animate in cleanly
 * on first paint.
 */
export const PageShell = ({
  title,
  description,
  breadcrumbs,
  actions,
  children,
}: PageShellProps): React.JSX.Element => (
  <motion.div initial="hidden" animate="show" variants={stagger} className="space-y-6">
    <motion.div variants={fadeUp}>
      <UzPageHeader
        title={title}
        description={description}
        breadcrumbs={breadcrumbs}
        actions={actions}
      />
    </motion.div>
    <motion.div variants={fadeUp}>{children}</motion.div>
  </motion.div>
);
